import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service6 from "../../assets/images/service/06.jpg";

import ImgKidney from "../../assets/images/service_detail/urologic/01.jpg";
import ImgBladder from "../../assets/images/service_detail/urologic/02.jpg";
import ImgProstate from "../../assets/images/service_detail/urologic/03.jpg";
import ImgSurgery from "../../assets/images/service_detail/urologic/04.jpg";

const OncologyData = () => {

const data = {
title:"Urologic Oncology Treatment",
subtitle:"Advanced cancer treatment",

heading:"Best Urologic Cancer Treatment",
description:"Urologic oncology focuses on diagnosis and treatment of cancers related to kidney, bladder, prostate and urinary system.",

image:Service6,

sections:[

{
title:"What is Urologic Oncology?",
content:"Urologic oncology is a specialized branch of urology that focuses on diagnosis and treatment of cancers related to urinary system and male reproductive organs. It includes cancers of kidney, bladder, prostate, testicles and urinary tract. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia provides advanced urologic cancer treatment using modern technology and comprehensive care ensuring best outcomes for patients.",
image: ImgKidney
},

{
title:"Types of Urologic Cancers",
content:"Urologic oncology focuses on cancers affecting the urinary system and male reproductive organs. Early detection and specialized treatment significantly improve survival and recovery outcomes.",
list:[
"Kidney Cancer – Tumor developing in kidney tissues that may cause pain or blood in urine.",
"Bladder Cancer – Cancer of bladder lining commonly presenting with painless blood in urine.",
"Prostate Cancer – Cancer of prostate gland, often detected through PSA testing.",
"Testicular Cancer – Tumor in testicles, usually seen as painless swelling or lump.",
"Ureter & Urinary Tract Cancers – Rare cancers affecting urine passage from kidney to bladder."
],
image: ImgBladder
},

{
title:"Symptoms of Urologic Cancer",
content:"Urologic cancers may show subtle early signs. Timely medical consultation is important if any unusual symptoms are noticed.",
list:[
"Blood in urine – One of the most common warning signs.",
"Pain in lower abdomen or back – May indicate kidney or bladder involvement.",
"Frequent urination – Especially in prostate or bladder conditions.",
"Difficulty in urination – Weak flow or blockage symptoms.",
"Unexplained weight loss – Seen in advanced cancer cases.",
"Swelling in testicles – Possible sign of testicular cancer.",
"Fatigue and weakness – General symptom of chronic illness."
],
image: ImgProstate
},

{
title:"Diagnosis of Urologic Cancer",
content:"Accurate diagnosis helps determine cancer type, stage and appropriate treatment plan. Early detection improves treatment success and survival rate.",
list:[
"Ultrasound & CT Scan – To detect tumors and assess spread.",
"MRI Scan – Detailed imaging for staging and surgical planning.",
"Blood & Urine Tests – To evaluate organ function and tumor markers.",
"PSA Test – Screening test for prostate cancer.",
"Biopsy – Confirmatory test to identify cancer cells.",
"Cystoscopy – Direct examination of bladder using camera."
]
},

{
title:"Treatment Options for Urologic Cancer",
content:"Treatment depends on cancer type, size and stage. Advanced surgical and minimally invasive techniques ensure better outcomes and faster recovery.",
list:[
"Cancer Surgery – Removal of tumor or affected organ tissue.",
"Laser Surgery – Minimally invasive treatment for selected tumors.",
"Laparoscopic / Minimally Invasive Surgery – Smaller incisions, less pain and quicker recovery."
],
image: ImgSurgery
},

{
title:"Benefits of Early Cancer Treatment",
content:"Early diagnosis and timely treatment significantly improve long-term survival and reduce complications.",
list:[
"Higher success and cure rate",
"Reduced spread of cancer",
"Organ preservation in early stages",
"Less aggressive treatment required",
"Improved overall quality of life"
]
},

{
title:"Post Treatment Care & Monitoring",
content:"Regular follow-up and monitoring are essential after cancer treatment to detect recurrence early and maintain overall health.",
list:[
"Routine follow-up consultations",
"Periodic scans and blood tests",
"Healthy diet and lifestyle",
"Emotional and psychological support",
"Long-term medical monitoring"
]
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Urologic Cancer Treatment?",
content:"Dr. Sachitanand Chaurasia is an experienced urologist known for advanced cancer treatment and patient care. At BBMH (Brijesh Banger Memorial Hospital), patients receive modern diagnostic facilities, advanced surgical treatment and complete care under one roof. The focus is on early diagnosis, accurate treatment and better recovery for every patient."
}

],

faq:[
{q:"Is urologic cancer treatable?",a:"Yes if diagnosed early."},
{q:"Symptoms?",a:"Blood in urine, pain, swelling."},
{q:"Best treatment?",a:"Depends on cancer stage."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default OncologyData;
